import { Application } from '@hotwired/stimulus'

const application = Application.start()
const controllers = import.meta.glob('./**/*_controller.js', { eager: true })

for (const [path, controller] of Object.entries(controllers)) {
  const identifier = path
    .replace(/^\.\//, '')
    .replace(/_controller\.js$/, '')
    .replaceAll('_', '-')
    .replaceAll('/', '--')

  application.register(identifier, controller.default)
}

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
